import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';

const AccountLabel = ({ account }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const handleExpandClick = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <>
      <style>
        {`
          /* =================================
             ACCOUNT ARROW BUTTON - DESKTOP
             ================================= */
          .account-expand-button {
            margin-left: 12px;
            cursor: pointer;
            color: #004aad;

            width: 34px;
            height: 26px;

            padding: 0;
            border-radius: 4px;

            display: flex;
            align-items: center;
            justify-content: center;

            font-size: 12px;
            line-height: 1;
            font-weight: normal;

            flex-shrink: 0;
          }

          .account-expand-button svg {
            width: 15px;
            height: 15px;
            display: block;
            stroke-width: 1.5;
          }

          /* =================================
             SMALL SCREEN
             ORIGINAL SIZE - NO CHANGE
             ================================= */
          @media (max-width: 600px) {
            .account-expand-button {
              margin-left: 8px;
              cursor: pointer;
              background-color: #004aad;
              color: white;

              width: auto;
              height: auto;

              padding: 1px 5px;
              border-radius: 4px;

              display: flex;
              align-items: center;
              justify-content: center;

              font-size: 10px;
              line-height: 1;
            }

            .account-expand-button svg {
              width: 10px;
              height: 10px;
              display: block;
            }
          }
        `}
      </style>

      {/* =================================
          ACCOUNT SECTION
          (Font/Weight/Size SAME, sirf spacing aligned)
          ================================= */}
      <div
        style={{
          margin: "0",
          padding: "0",
          textAlign: "left",
        }}
      >
        <p
          style={{
            fontWeight: 'bold',
            fontSize: "18px",
            margin: "0 0 2px 0",
            padding: "0",
            textAlign: "left",
          }}
        >
          Account:
        </p>

        <div
          style={{
            display: "flex",
            alignItems: "center",
            margin: "0",
            padding: "0",
            textAlign: "left",
          }}
        >
          <Link
            to="/TabsWorking"
            style={{
              textDecoration: "none",
              fontWeight: "normal",
              color: "#004aad",
              fontSize: "14px",
              lineHeight: "1.2",
              margin: "0",
              padding: "0",
            }}
          >
            {account}
          </Link>

          <div
            className="account-expand-button"
            onClick={handleExpandClick}
          >
            {isExpanded ? (
              <FaChevronUp />
            ) : (
              <FaChevronDown />
            )}
          </div>
        </div>

        {isExpanded && (
          <div
            style={{
              marginTop: "4px",
              paddingLeft: "0px",
              color: "#333",
              fontSize: "14px",
              fontWeight: "normal",
            }}
          >
            <p style={{ margin: '1px 0' }}>
              2D VICARAGE ROAD
            </p>

            <p style={{ margin: '1px 0' }}>
              BIRMINGHAM BIR GB B14 7RA
            </p>

            <p style={{ margin: '1px 0' }}>
              Phone: 0121 444 0496
            </p>

            <p style={{ margin: '1px 0' }}>
              Email: Communications@allsaintsdentalclinic.co.uk
            </p>
          </div>
        )}
      </div>
    </>
  );
};

export default AccountLabel;